import railyApiService from "../raily-api.service";
import MetaAttentionCountersResponse from "./attention-counters/meta-attention-counters.response";
import metaBillingsCargoTaxiStatusCountersRequestFactory from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters-request.factory";
import MetaBillingsCargoTaxiStatusCountersRequest from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.request";
import MetaBillingsCargoTaxiStatusCountersResponse from "./billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters.response";
import MetaBillingsTaxiTaxiStatusCountersResponse from "./billings/taxi-taxi/status-counters/meta-billings-taxi-taxi-status-counters.response";

const metaBillingsApiService = () => {
  const getAttentionCounters = (
    abortSignal: AbortSignal,
  ): Promise<MetaAttentionCountersResponse> => {
    const url = `/meta/attention-counters`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getCargoTaxiStatusCounters = (
    request: MetaBillingsCargoTaxiStatusCountersRequest,
    abortSignal: AbortSignal,
  ): Promise<MetaBillingsCargoTaxiStatusCountersResponse> => {
    const url = `/meta/billing-cargo-taxi-status-counters`;

    const queryParams =
      metaBillingsCargoTaxiStatusCountersRequestFactory.create(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getTaxiTaxiStatusCounters = async (
    abortSignal: AbortSignal,
  ): Promise<MetaBillingsTaxiTaxiStatusCountersResponse> => {
    const url = `/meta/billing-taxi-taxi-status-counters`;

    return railyApiService().get<MetaBillingsTaxiTaxiStatusCountersResponse>({
      url,
      abortSignal,
    });
  };

  return {
    getAttentionCounters,
    getCargoTaxiStatusCounters,
    getTaxiTaxiStatusCounters,
  };
};

export default metaBillingsApiService;
